import React, { Component, useState } from 'react';
import { 
    Navbar,
    Nav,
    NavbarBrand,
    NavItem,
    Container,
    NavbarText,
    NavbarToggler,
    Collapse
} from "reactstrap";
import { Link, useLocation  } from "react-router-dom";
import StickyHeader from 'react-sticky-header';
import '../../../node_modules/react-sticky-header/styles.css';
import logo from "../../assets/images/logo.png";

export default function NavbarPage() {
    const location = useLocation();
    const hideEventButton = location.pathname.startsWith("/detail") || location.pathname.startsWith("/form-order");

    const [collapsed, setCollapsed] = useState(true);

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const navItems = [
        { id: 1, idnm: "beranda", navheading: "Beranda", to: '/' },
        { id: 2, idnm: "tentang", navheading: "Tentang", to: '#footer' },
        { id: 3, idnm: "testimoni", navheading: "Testimoni", to: '#' },
        { id: 4, idnm: "kontak", navheading: "Kontak", to: '#footer' },
    ];

    return (
        <StickyHeader
            header={
                <Navbar container={false} expand="lg" fixed="top" className="navbar-custom sticky">
                    <Container className='nav-style'>
                        <NavbarBrand className="logo text-uppercase" href="/">
                            <img src={logo} alt="logo" height="45" />
                        </NavbarBrand>
                        <NavbarToggler onClick={toggleNavbar} className="me-2" />
                        <Collapse isOpen={!collapsed} navbar>
                            <Container className='w-custom'>
                                <Nav navbar className="justify-content-end" id="mySidenav">
                                    {navItems.map((item) => (
                                        <NavItem key={item.id}>
                                            {item.to.startsWith("#") ? (
                                                <a href={item.to} style={{ cursor: 'pointer' }}>{item.navheading}</a>
                                            ) : (
                                                <Link to={item.to}>{item.navheading}</Link>
                                            )}
                                        </NavItem>
                                    ))}
                                </Nav>
                            </Container>
                            {!hideEventButton && (
                                <div className='btn-event-container'>
                                    <a href='#events' className='btn-event'>Lihat Event</a>
                                </div>
                            )}
                        </Collapse>
                    </Container>
                </Navbar>
            }
            stickyOffset={-100}
        />
    );
}